<ng-container>
  @if (answerControl.enabled && !this.isASCLD) {
  <nh-field
    [id]="topLevelName"
    [label]="label"
    class="label-section"
    [labelSize]="topLevelLabelSize"
    [col9]="topLevelCol9"
  >
    @if (popupText) {
    <nh-popover
      class="ps-1 field-label icon-padding"
      [content]="popupText"
    ></nh-popover>
    }
    <div class="hint">{{ topLevelHint | globalTranslate }}</div>
    <ng-content select="[top-level-info]"></ng-content>
    <select
      nhTranslate
      name="topLevelAnswer"
      [attr.aria-label]="label"
      bindValue="code"
      [empty]="{ code: 'EMPTY', value: '' }"
      [items]="options"
      [formControl]="answerControl"
      required
    ></select>
    @if (answerControl.touched && answerControl.value === 'EMPTY') {
    <span class="form-text invalid-tooltip d-block">{{
      "REQUIRED" | globalTranslate
    }}</span>
    }
  </nh-field>
  } @if (this.isASCLD && initialTopLevelAnswer === 'EMPTY') {
  <nh-field
    [id]="topLevelName"
    [label]="label"
    class="label-section"
    [labelSize]="topLevelLabelSize"
    [col9]="topLevelCol9"
  >
    @if (popupText) {
    <nh-popover class="ps-1 field-label" [content]="popupText"></nh-popover>
    }
    <div class="hint">{{ topLevelHint | globalTranslate }}</div>
    <ng-content select="[top-level-info]"></ng-content>
    <select
      nhTranslate
      name="topLevelAnswer"
      [attr.aria-label]="label"
      bindValue="code"
      [empty]="{ code: 'EMPTY', value: '' }"
      [items]="options"
      [formControl]="answerControl"
      required
    ></select>
    @if (answerControl.touched && answerControl.value === 'EMPTY') {
    <span class="form-text invalid-tooltip d-block">{{
      "REQUIRED" | globalTranslate
    }}</span>
    }
  </nh-field>
  } @if (showForm$ | async) {
  <ng-content></ng-content>
  }
</ng-container>